import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { ActivateComponent } from "./activate/activate.component";
import { ActivateTokenGuard, NotLoggedInGuard, ResetTokenGuard } from "./auth.guards";
import { ForgotPasswordComponent } from "./forgot-password/forgot-password.component";
import { LoginComponent } from "./login/login.component";
import { ResetPasswordComponent } from "./reset-password/reset-password.component";

const routes: Routes = [
  {
    path: "login",
    component: LoginComponent,
    data: { title: "Login" },
    canActivate: [NotLoggedInGuard],
  },
  {
    path: "forgotPassword",
    component: ForgotPasswordComponent,
    data: { title: "Forgot Password" },
    canActivate: [NotLoggedInGuard],
  },
  {
    path: "resetPassword/:reset_token",
    data: { title: "Reset Password" },
    component: ResetPasswordComponent,
    canActivate: [NotLoggedInGuard, ResetTokenGuard],
  },
  {
    path: "resetPassword",
    canActivate: [NotLoggedInGuard],
    redirectTo: "/auth/forgotPassword",
  },
  {
    path: "activate/:activation_token",
    data: { title: "User Activation" },
    component: ActivateComponent,
    canActivate: [NotLoggedInGuard, ActivateTokenGuard],
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthRoutingModule {}

// Lazy load auth module
const authModuleLazyLoadRoutes: Routes = [
  {
    path: "auth",
    loadChildren: () => import("./auth.module").then((m) => m.AuthModule),
  },
];

export { authModuleLazyLoadRoutes };
